import styled from 'styled-components';

const BGImg = styled.img`
  max-height: 100vh;
  height: 100%;
  min-width: ${(props) => props.minWidth && '100vw'};
  width: auto;
  z-index: auto;
  pointer-events: none;
`;

export default BGImg;



// WEBPACK FOOTER //
// ./src/components/Parallax/ParallaxBgImg/ParallaxBgImg.js